import { t } from "i18next";
import React from "react";
import { useLocation } from "react-router-dom";
import phFeMale from "../../../assets/images/blurred2/payment/female-transform.webp";
import phMale from "../../../assets/images/blurred2/payment/male-transform.webp";
import ImageLoader from "../../../components/ImageLoader";
import { addS3Url, checkGender } from "../../../utils/modules";

const image = {
  male: {
    src: addS3Url("/payment/male-transform.png"),
    placeHolderImage: phMale,
  },
  female: {
    src: addS3Url("/payment/female-transform.png"),
    placeHolderImage: phFeMale,
  },
};

const Transformation = ({ gender }) => {
  const location = useLocation();
  const paramsGender =
    checkGender(location?.state?.gender) || checkGender(gender) || "female";

  return (
    <div
      className="w-100 pb-2"
      style={{ borderRadius: "4px", border: "1px solid #DBDBDB" }}
    >
      <div className="transformation-title-container d-flex flex-row justify-content-between py-2">
        <div className="now-label">{t("payment.now")}</div>
        <div className="now-label goal-label">{t("payment.goal")}</div>
      </div>
      <div className="pt-4" style={{ backgroundColor: "#E4E5EA" }}>
        <ImageLoader
          alt="female"
          style={{
            width: "100%",
            minHeight: 100,
            position: "relative",
            zIndex: 2,
          }}
          {...image[paramsGender]}
        />
        <div className="arrow-container animateArrow">
          <img
            src={addS3Url("/payment/ng-arrows.svg")}
            className="arrow"
            alt=""
          />
        </div>
      </div>
      <div className="w-100 d-flex flex-column px-3 py-3">
        <div className="d-flex flex-row justify-content-between">
          <div>
            <p className="m-0 p-0 fw-bold fs18 text-start">
              {t("payment.flexibility")}
            </p>
            <img
              alt=""
              src={addS3Url("/payment/flex-low.svg")}
              className="w-100"
            />
          </div>
          <div>
            <p className="m-0 p-0 fw-bold fs18 text-start">
              {t("payment.flexibility")}
            </p>
            <img
              alt=""
              src={addS3Url("/payment/flex-high.svg")}
              className="w-100"
            />
          </div>
        </div>
        <div className="mt-4 d-flex flex-row justify-content-between">
          <div>
            <p className="m-0 p-0 fw-bold fs18 text-start">
              {t("payment.earning_power")}
            </p>
            <img
              alt=""
              src={addS3Url("/payment/income-low.svg")}
              className="w-100"
            />
            <p style={{ color: "#989898" }} className="m-0 p-0 text-start">
              {t("payment.limited")}
            </p>
          </div>
          <div>
            <p className="m-0 p-0 fw-bold fs18 text-start">
              {t("payment.earning_power")}
            </p>
            <img
              alt=""
              src={addS3Url("/payment/income-high.svg")}
              className="w-100"
            />
            <p
              style={{ color: "#989898" }}
              id="get-plan-scroll"
              className="m-0 p-0 text-start"
            >
              {t("payment.high")}
            </p>
            <p id="get-plan-scroll-new" className="m-0 p-0"></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transformation;
